import { render, staticRenderFns } from "./projectManage.vue?vue&type=template&id=2d66ae08&scoped=true&"
import script from "./projectManage.vue?vue&type=script&lang=js&"
export * from "./projectManage.vue?vue&type=script&lang=js&"
import style0 from "./projectManage.vue?vue&type=style&index=0&id=2d66ae08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d66ae08",
  null
  
)

export default component.exports